import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "./Login";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell title="Reset Your Password" subtitle="Enter your account email and we'll send a reset link.">
      {sent ? (
        <div className="bg-emerald-500/10 border border-emerald-500/40 text-emerald-300 text-sm rounded-xl px-4 py-3" data-testid="forgot-success">
          If that email is registered, a reset link has been sent. The link expires in 1 hour.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          {error && <div className="bg-red-500/10 border border-red-500/40 text-red-300 text-sm rounded-xl px-4 py-3" data-testid="forgot-error">{error}</div>}
          <div>
            <Label htmlFor="fp-email">Email</Label>
            <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-navy-base border-white/15 text-white mt-1" data-testid="forgot-email-input" />
          </div>
          <Button type="submit" disabled={submitting} className="w-full bg-orange-600 hover:bg-orange-700 text-white font-semibold transition-colors" data-testid="forgot-submit-btn">
            {submitting ? "Sending…" : "Send Reset Link"}
          </Button>
        </form>
      )}
      <p className="text-sm text-slate-400 mt-6 text-center">
        <Link to="/login" className="text-orange-400 hover:text-orange-300 font-medium transition-colors" data-testid="back-to-login">Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
